import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/default-props-match-prop-types */
import { useContext, useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { DropdownContext } from './dropdown';
import styles from './styles.module.scss';
import { getPositioningStyle } from './positioning';
export var DropdownContent = function (_a) {
    var children = _a.children, side = _a.side, _b = _a.sideOffset, sideOffset = _b === void 0 ? 0 : _b, align = _a.align, _c = _a.alignOffset, alignOffset = _c === void 0 ? 0 : _c, className = _a.className;
    var context = useContext(DropdownContext);
    if (!context) {
        throw new Error('DropdownContent must be used within a Dropdown');
    }
    var isOpen = context.isOpen;
    var containerRef = useRef(null);
    var _d = useState({}), style = _d[0], setStyle = _d[1];
    var defaultClassName = isOpen ? styles['content--visible'] : styles['content--hidden'];
    var _e = useState(cx(defaultClassName, className)), cssClasses = _e[0], setCssClasses = _e[1];
    useEffect(function () {
        if (!isOpen) {
            setCssClasses(cx(styles['content--hidden'], className));
            setStyle({});
            return;
        }
        var nextStyle = getPositioningStyle({
            side: side,
            sideOffset: sideOffset,
            align: align,
            alignOffset: alignOffset,
        });
        setStyle(nextStyle);
        setCssClasses(cx(styles['content--visible'], className));
    }, [isOpen, side, sideOffset, align, alignOffset]);
    return (_jsx("div", { ref: containerRef, className: cssClasses, style: style, children: children }));
};
DropdownContent.defaultProps = {
    side: 'bottom',
    sideOffset: 0,
    align: 'start',
    alignOffset: 0,
    className: '',
};
